import { Swiper, Navigation } from "vendor";

if (!customElements.get("catalog-slider")) {
  class CatalogSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.swiper = new Swiper(this, {
        slidesPerView: 2.1,
        spaceBetween: 10,
        modules: [Navigation],
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 20,
          }
        },
        a11y: {
          prevSlideMessage: window.accessibilityStrings.prevSlide,
          nextSlideMessage: window.accessibilityStrings.nextSlide,
        },
        navigation: {
          nextEl: this.querySelector(".swiper-button-next"),
          prevEl: this.querySelector(".swiper-button-prev"),
        },
        on: {
          init: () => {
            this.classList.add("initialized");
            this.setAttribute("data-active-index", this.swiper.realIndex);
          },
          slideChange: () => {
            this.setAttribute("data-active-index", this.swiper.realIndex);
          },
        },
      });
    }
  }

  customElements.define("catalog-slider", CatalogSlider);
}
